import React from "react";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { siteConfig } from "../../data/mock";

const WhatsAppButton = () => {
  const phoneNumber = siteConfig.phone.replace(/[^0-9]/g, "");
  const message = encodeURIComponent(
    "Hola P&J Consultores, me gustaría solicitar más información sobre sus servicios."
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center group"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      title="Contactar por WhatsApp"
    >
      <div className="absolute right-full mr-3 bg-white text-[#0F172A] px-3 py-1.5 rounded-lg text-sm font-medium shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap hidden sm:block border border-[#0F172A]/5">
        ¿Te ayudamos por WhatsApp?
      </div>
      <MessageCircle size={28} />
    </motion.a>
  );
};

export default WhatsAppButton;
